import Menu from './Menu.vue';
import MenuList from './views/MenuList.vue';
import MenuEditor from './views/MenuEditor';

export const menuRoutes = [
  {
    path: 'menu',
    component: Menu,
    children: [
      { path: ':menuGuid', component: MenuEditor, name: 'menuEditor' },
      { path: ':menuGuid/section/:sectionGuid', component: MenuEditor, name: 'sectionEditor' },
      { path: '', component: MenuList, name: 'menuList' }
    ]
  }
];
